export const isMPDocumentNumberValid = (MPDocumentNumber: string) => {
  const regex = /^MPN\d{9}$/;
  return regex.test(MPDocumentNumber);
};

export const isRFQSummaryDocumentNumberValid = (RFQSummaryDocumentNumber: string) => {
  const regex = /^RS\d{8}$/;
  return regex.test(RFQSummaryDocumentNumber);
};
